import type { ApiResponse } from '@/src/api/types';

export function response<T>(
  data: T,
  status = 200,
  headers: Headers = new Headers({ 'x-csrf-token': 'mock-csrf-token' }),
): ApiResponse<T> {
  return {
    data: JSON.parse(JSON.stringify(data)),
    status,
    headers,
  };
}
